<script>

	export let ref;
	export let value = 100;
	export let min = 0;
	export let max = 100;
	export let step = 1;
	export let stops = undefined;

</script>

<style>

	.range {
		display: flex;
		align-items: center;
		height: 100%;
		flex: 1 0 auto;
	}

	input[type=range] {
		-webkit-appearance: none;
		width: 100%;
		height: 18px;
		border: 0;
		padding: 0;
		border-radius: 0;
		background: transparent !important;
		transition: opacity 0.4s ease-in-out;
	}

	input[type=range]::-webkit-slider-runnable-track {
		background: transparent;
		border: 0;
		border-bottom: 2px solid var(--blend-40);
		box-sizing: content-box;
		height: 0;
	}

	input[type=range]::-moz-range-track {
		background: transparent;
		border: 0;
		border-top: 1px solid var(--blend-40);
		border-bottom: 1px solid var(--blend-40);
		box-sizing: content-box;
		height: 0;
		position: absolute;
		top: 50%;
		left: 0;
		width: 100%;
	}

	input[type=range]::-webkit-slider-thumb {
		-webkit-appearance: none;
		box-sizing: content-box;
		border: 1px solid var(--bgColor);
		width: 18px;
		height: 18px;
		border-radius: 50%;
		background: var(--accentColor);
		margin-top: -9px;
	}

	input[type=range]::-moz-range-thumb {
		border: 1px solid var(--bgColor);
		box-sizing: content-box;
		width: 18px;
		height: 18px;
		border-radius: 50%;
		background: var(--accentColor);
	}

	input[type=range]:focus,
	input[type=range]:active {
		outline: none;
	}

	input[type=range]::-moz-focus-outer {
		border: 0;
	}

</style>

<div class="range">
	<input
		type="range"
		id="{ref}"
		min="{min}"
		max="{max}"
		step="{step}"
		bind:value={value}
		list="{ stops ? ref + '_stops' : null }"
	/>
	{#if stops}
		<datalist id="{ref}_stops">
			{#each stops as p}
				<option>{p}</option>
			{/each}
		</datalist>
	{/if}
</div>